import { Auth0Provider } from '@auth0/auth0-react';
import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from 'Store/Store';
import './Assets/Styles/index.sass';
import { ROUTE } from './Services/Route/Route.types';
import { VersionProvider } from './Services/VersionContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'

const store = configureStore({});
export const isProduction = process.env.REACT_APP_ENVIRONMENT === 'prod';
export const isStaging = process.env.REACT_APP_ENVIRONMENT === 'staging';

const auth0_domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
const auth0_clientid = process.env.REACT_APP_AUTH0_CLIENTID || '';
const auth0_audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';

if (!process.env.REACT_APP_AUTH0_DOMAIN
  || !process.env.REACT_APP_AUTH0_CLIENTID
  || !process.env.REACT_APP_AUTH0_AUDIENCE) {
    console.error("SET ENVIRONMENT VARIABLES");
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 3,
			retryDelay: 250
		},
	},
});

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
root.render(
	<React.StrictMode>
		<Auth0Provider
			domain={auth0_domain}
			clientId={auth0_clientid}
			audience={auth0_audience}
			redirectUri={window.location.origin + ROUTE.AUTH0_CALLBACK}
			scope="openid profile email offline_access"
			useRefreshTokens={true}
			cacheLocation="localstorage"
		>
			<HelmetProvider>
				<VersionProvider>
					<QueryClientProvider client={queryClient}>
						<BrowserRouter>
							<Provider store={store}>
								<Helmet>
									{ isProduction && <script src='gtm.js' /> }
									{ isStaging && <script src='gtm-staging.js' /> }
								</Helmet>
								<App />
							</Provider>
						</BrowserRouter>
						<ReactQueryDevtools initialIsOpen={false} />
					</QueryClientProvider>
				</VersionProvider>
			</HelmetProvider>
		</Auth0Provider>
	</React.StrictMode>
);